<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <path d="M24 0v24H0V0z" />
            <path
                d="M15.38 8.5H8.62L12 5.12l3.38 3.38M19 10l-7-7-7 7h14ZM8.62 15.5h6.76L12 18.88 8.62 15.5M5 14l7 7 7-7H5Z"
                fill="#000"
                fill-rule="nonzero"
            />
        </g>
    </svg>
</template>
